<template>
  <div id="user-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden body-module-height z-20">
    <user-sidebar :is-sidebar-active="openSideBar" @closeSidebar="closeDataSideBar" :user-id="userIdSidebar"/>

    <google-fy :queried-string="searchQuery" @clear-search="clearSearch" @search="searchUsers"/>

    <div class="vx-row hidden md:flex items-center mb-2 h-12">
      <div class="vx-col w-1/2 md:w-1/12 text-left"> Avatar </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Nome </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Email </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Nick </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-center"> Role </div>
      <div class="vx-col w-1/2 md:w-1/6 flex justify-end">
        <vs-button type="border" color="primary" icon-pack="feather" icon="icon-plus" size="small" @click="updateUserEdit(0)"
                   class="flex justify-center md:text-xs lg:text-base">
          {{ $t('buttons.add') }}
        </vs-button>
      </div>
    </div>

    <bds-scroll-area component-class="content-scroll-area specific-height" v-if="loaded">
      <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
        <li class="cursor-pointer email__mail-item" v-for="(value, key, index) in users" :key="key" @click="updateUserEdit(key)"
            :style="{transitionDelay: (index * 0.1) + 's'}">
          <user-list-item :user-param="value" @removeUser="removeUser"/>
        </li>
      </transition-group>
    </bds-scroll-area>
  </div>
</template>

<script>
import UserListItem from "@/views/users/UserListItem";
import UserSidebar from './users/UserSidebar.vue';
import UserService from '@/services/User.service';
import {showErrorNotify, showSuccessNotify} from "@/helpers/functionsHelpers";
import GoogleFy from "@/views/components/GoogleFy";

export default {
  components: {
    UserListItem,
    UserSidebar,
    GoogleFy
  },
  props: {

  },
  data () {
    return {
      // Data Sidebar
      openSideBar: false,
      userIdSidebar: 0,

      searchQuery: null,

      totalUsers: 0,
      usersPerPage: 0,
      loaded: false,

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 30,
        wheelSpeed: .60,
        minScrollbarLength: 20,
        suppressScrollX: true
      },
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    users() {
      return this.$store.getters['Users/getUsers'];
    },
  },
  methods: {
    toggleUserSidebar(val = false) {
      this.openSideBar = val;
    },
    closeDataSideBar() {
      this.toggleUserSidebar(false);
      this.userIdSidebar = 0;
    },
    updateUserEdit(userId) {
      this.userIdSidebar = Number(userId);
      this.toggleUserSidebar(true);
    },
    removeUser(userId) {
      UserService.delete(userId).then((response) => {
        this.$store.dispatch('Users/removeUser', response).then(() => {
          showSuccessNotify(this, 'Removido com sucesso');
        });
      }, (error) => {
        showErrorNotify(this, error);
      });
    },
    toggleFilter(open = true) { //TODO change name of function to search
      if (!open) {
        this.searchQuery = 'all';
      }
      this.updateSearch();
    },
    clearSearch() {
      return this.$store.dispatch('Users/clearUsers').then(() => {
        this.searchQuery = null;
      });
    },
    searchUsers(query) {
      const query_string = query || 'all';

      return this.clearSearch().then(() => {
        return UserService.list(query_string).then((response) => {
          this.totalUsers = response.totalUsers;
          this.usersPerPage = response.users.length;
          return this.$store.dispatch('Users/setUsers', response.users).then(() => {
            this.searchQuery = query;
            return Promise.resolve();
          });
        }, error => {
          showErrorNotify(this, error);
          return Promise.reject();
        });
      });
    },
    updateSearch() {
      this.loading();
      this._.debounce((payload, vm) => {
        if (!payload) {
          vm.loading(false);
          return;
        }
        vm.requestQueryUser().then(() => {
          vm.loading(false);
        }, () => {
          vm.loading(false);
        });

      }, 500)(this.searchQuery, this);
    },
    loading(open = true) {
      if (open) {
        this.$vs.loading({
          container: this.$refs.searchInput.$el,
          scale: 0.45
        });
      } else {
        this.$vs.loading.close(this.$refs.searchInput.$el);
      }
    },
  },
  created() {
  },
  mounted() {
    this.clearSearch().then(() => {
      this.loaded = true;
    });
  }
}
</script>

<style lang="scss">
#user-app {
  .content-scroll-area.specific-height {
    height: calc(100% - 4rem);
  }

  @media screen and (min-width: $screen-md-min) {
    .content-scroll-area.specific-height {
      height: calc(100% - 4rem - 4rem);
    }
  }
}
</style>
